import { render, staticRenderFns } from "./SocialMediaMentionsBlock.vue?vue&type=template&id=ac7434bc&scoped=true"
import script from "./SocialMediaMentionsBlock.vue?vue&type=script&lang=js"
export * from "./SocialMediaMentionsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac7434bc",
  null
  
)

export default component.exports